import React from 'react';
import ClinicalNoteForm from '../../../global/component/ClinicalNote/ClinicalNoteForm';
import { ClinicalNoteType } from '../../../global/entities/ClinicalNote/ClinicalNote';

const PhysicalExaminationForm: React.FC = () => (
  <ClinicalNoteForm
    config={{
      noteType: ClinicalNoteType.PhysicalExam,
      i18nPrefix: 'physicalExamination',
      returnPath: '/hcpPatientDashboard/medicalInformation',
    }}
  />
);

export default PhysicalExaminationForm;
